var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"text",attrs:{"contenteditable":_vm.contenteditable},on:{"blur":v => _vm.$emit('input', v.target.innerText),"paste":_vm.onPaste}},[_c('span',{ref:"innerText",domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }